<script>

    import * as echarts from 'echarts'
    import { onMount } from 'svelte'

    import GraphicsService from '../$services/graphics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    export let dateStart = null
    export let dateEnd = null

    let chartContainer
    let chart
    let ready = false
    let total = 0

    onMount(() => {
        chart = echarts.init(chartContainer)
        ready = true

        const resize = () => chart.resize()
        window.addEventListener('resize', resize)

        return () => {
            window.removeEventListener('resize', resize)
            chart.dispose()
            chart = null
            ready = false
        }
    })

    $: if (ready) load(dateStart, dateEnd)

    async function load(start, end) {
        if (!chart || !start || !end) return

        const res = await GraphicsService.getOverweightMonths({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data ?? res
        const values = data?.datasets?.[0]?.data || []

        total = values.reduce((sum, value) => sum + Number(value || 0), 0)

        if (!data?.labels) return

        chart.setOption({
            color: ['#b7791f'],
            tooltip: {
                trigger: 'axis',
                valueFormatter: value => NumeralMethods.cash(value)
            },
            grid: {
                left: 8,
                right: 8,
                top: 16,
                bottom: 8,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                data: data.labels,
                axisLine: { lineStyle: { color: '#e5e7eb' } },
                axisTick: { show: false },
                axisLabel: { color: '#9ca3af', fontSize: 11 },
            },
            yAxis: {
                type: 'value',
                splitLine: { lineStyle: { color: '#f3f4f6' } },
                axisLabel: {
                    color: '#9ca3af',
                    fontSize: 11,
                    formatter: value => NumeralMethods.cash(value)
                },
            },
            series: [{
                name: 'Sobrepesos',
                type: 'bar',
                barMaxWidth: 36,
                itemStyle: { borderRadius: [6, 6, 0, 0] },
                data: values,
            }],
        }, true)
    }

</script>

<div class="graphic-card">
    <div class="header">
        <div class="icon">
            <i class="fas fa-weight"></i>
        </div>
        <div>
            <h3 class="title">Sobrepesos registrados</h3>
            <p class="total">{ NumeralMethods.cash(total) } en el periodo</p>
        </div>
    </div>

    <div bind:this={chartContainer} class="chart"></div>
</div>

<style>
    .graphic-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .header {
        display: flex;
        align-items: center;
        gap: 0.65rem;
        margin-bottom: 1rem;
    }

    .icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #fff6e0;
        color: #b7791f;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.9rem;
        flex-shrink: 0;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0;
        line-height: 1.2;
    }

    .total {
        margin: 0.15rem 0 0;
        font-size: 0.85rem;
        color: #9e9e9e;
    }

    .chart {
        width: 100%;
        height: 320px;
    }
</style>
